export default __webpack_public_path__ + "static/media/item.4ffbd388.png";